import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>To perform an inquiry on a different recipient</p>
				
				<div className="button" onClick={()=>this.props.navigate( 'A2')}>Click Here</div>
			</div>
		);
	}
}